export default {
  en: {
    dismiss: 'Close'
  },
  fr: {
    dismiss: 'Fermer'
  }
};